export const TIMELY_FILING_LIMIT_DAYS = 90

const JOYFUL_BOT_USER_ID = '54edbc39-493b-4df7-bea9-553d23946587'
const BILLER_BOT_USER_ID = 'bd9ee2f2-4198-4f64-b44e-ccb5c951fbb1'
const QA_BOT_USER_ID = '022ce000-2078-4c1f-a014-d37fa2e7b400'

export const BOT_USER_IDS = new Set([
  JOYFUL_BOT_USER_ID,
  BILLER_BOT_USER_ID,
  QA_BOT_USER_ID,
])
